// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/thigh-springs-in-lighting-technology/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteThighSpringsInLightingTechnologyEN: PageEntry = {
  id: "example.produkte-schenkelfeder-in-der-beleuchtungstechnik",
  locale: "en",
  slug: "produkte/thigh-springs-in-lighting-technology",
  seo: {
    title: "Thigh springs in lighting technology | Dietz GmbH",
    description: "Thigh leather with inwardly curved spring end for fastening luminaires in cavity ceilings. Automation of the end of the spring bent into the spring body.",
  },
  type: "post",
  h1: "Thigh springs in lighting technology",
  intro: "Thigh leather with inwardly curved spring end for fastening luminaires in cavity ceilings. Automation of the end of the spring bent into the spring body.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ-schenkelfederLeuchten.jpg", alt: "Thigh springs in lighting technology", width: 1400, height: 1120 }
  ],
};
